module.exports = __webpack_public_path__ + "img/image.7b161f38.png";